var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-more-text",class:{ 'read-more-text--truncate': _vm.setLimit }},[_c('markdown-editor',{attrs:{"editable":false},model:{value:(_vm.localText),callback:function ($$v) {_vm.localText=$$v},expression:"localText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }